import React, {Component} from 'react';
import PropTypes from 'prop-types';
import RmField from "./RmField";
import {Editor} from '@tinymce/tinymce-react';

export default class RmTextareaField extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tinyEditor: null
        };
    }


    handleChange(e) {
        this.props.onChange(e.target.value);
    }

    handleTinyMceChange(e) {
        this.props.onChange(e.target.getContent());
    }

    handleClear() {
        if (this.state.tinyEditor) {
            this.state.tinyEditor.setContent('');
        }
    }

    render() {
        let {className, ...props} = this.props;

        if (!className) {
            className = "";
        }

        className += ` RmTinyField`;

        let io = <textarea className={"RmField__input"}
                        placeholder={this.props.label} name={this.props.id} value={this.props.value || ""}
                        onChange={this.handleChange.bind(this)} id={this.props.nonUnique ? null : this.props.id}
                           rows={this.props.rows || 3}
                        ref={(input) => {
                            this.refInput = input;
                        }} disabled={!!this.props.disabled}/>;

        if (this.props.useTinymce) {
            let tinyInit = {
                plugins: 'link image autolink textcolor',
                toolbar: 'bold italic underline | forecolor | image | alignleft aligncenter alignright | numlist bullist',
                statusbar: false,
                menubar: false,
                language: 'nl',
                language_url: '/tinymce_nl.js',
                height: 220,
                content_css: '/tinymce_content.css',
                setup: (editor) => {
                    this.setState({
                        tinyEditor: editor
                    });
                },
                images_upload_url: `${window.API_URL}/image/upload`,
                images_upload_credentials: true,
                // theme: 'modern',
                images_dataimg_filter: function(img) {
                    return img.hasAttribute('internal-blob');
                },
                relative_urls : false,
                remove_script_host : false,
                convert_urls : true,
                // mobile: {
                //     theme: 'mobile'
                // }
            };

            io = <Editor
                initialValue={this.props.value}
                init={tinyInit}
                onChange={this.handleTinyMceChange.bind(this)}
                id={this.props.id}
                apiKey={"ksxhsmgss7rxekn9dosdlvdcatzg55rkdrim1mwbyze1fz3s"}
            />
        }

        return (
            <RmField className={className} {...props}
                     inputType={"textarea"} inputOverride={io}
                     onClear={this.handleClear.bind(this)}
            />
        );
    }
}

RmTextareaField.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    iconName: PropTypes.string,
    value: PropTypes.any,
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
    marginOff: PropTypes.bool,
    className: PropTypes.string,
    rows: PropTypes.number,
    useTinymce: PropTypes.bool
};



// WEBPACK FOOTER //
// ./src/Forms/RmTextareaField.js